module.exports = __webpack_public_path__ + "static/media/ic_caution.8c0f66ee.svg";